// removed by extract-text-webpack-plugin
module.exports = {"SliderNavigation":"W9aX7rhJ0Ez-ii1AoXId0","navButtons":"H7nMAnp7B6vwy3GtRq6op","buttonWrapper":"rp11nQHCRuHM0XF_s4gGS","buttonNav":"_1TtLYyT8UWH2Zgmuy9li4G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderNavigation/SliderNavigation.css
// module id = 471
// module chunks = 8